import { useQuery } from '@tanstack/react-query';
import { fetchTraceGraphByInternalOrderId } from '@/api/orders';

export const internalOrderTraceGraphKeys = {
  detail: (id: string) => ['traceGraph', 'internal', id] as const,
};

export function useTraceGraphByInternalOrderId(ioId: string) {
  return useQuery({
    queryKey: internalOrderTraceGraphKeys.detail(ioId),
    queryFn: () => fetchTraceGraphByInternalOrderId(ioId).then(res => res.data),
    enabled: !!ioId,
  });
}
